import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './styles.less';

class Input extends React.Component {

    onChange = (val) => {
        this.props.onChange(val.target.value);
    }

    onClick = (e) => {
        const { onClick } = this.props;
        if (onClick && typeof onClick == 'function') {
            onClick(e);
        }
    }

    onKeyDown = (e) => {
        const { onKeyDown } = this.props;
        if (onKeyDown && typeof onKeyDown == 'function') {
            onKeyDown(e);
        }
    }

    componentWillReceiveProps(nextProps) {
        //  this.setState({value: nextProps.value});
    }

    render() {
        const {
            textColor,
            backColor,
            shadowColor,
            borderColor,
            isRounded,
            isShadow,
            direction,
            placeHolder,
            isBorder,
            value,
            isLocked
        } = this.props;

        var styles = {
            inputStyle: {
                color: textColor,
                backgroundColor: backColor,
                shadowColor: shadowColor
            },
            inputHolderStyle: {
                backgroundColor: shadowColor
            }
        };
        if (isBorder) {
            styles.inputStyle.border = '1px solid ' + (borderColor || '#000');
        } else {
            styles.inputStyle.border = 'none';
        }

        return (<div className={classnames(css.inputHolder, isRounded && css.rounded, isShadow && css.shadow, css[direction])}
            style={styles.inputHolderStyle} >

            <input
                className={css.input}
                placeholder={placeHolder}
                value={value}
                style={styles.inputStyle}
                onChange={this.onChange}
                onClick={this.onClick}
                onKeyDown={this.onKeyDown}
                disabled={isLocked}
            />
        </div>
        );
    }
}

Input.propTypes = {
    backColor: PropTypes.string,
    shadowColor: PropTypes.string,
    textColor: PropTypes.string,
    isBorder: PropTypes.bool,
    borderColor: PropTypes.string,
    direction: PropTypes.oneOf(['left', 'right']),
    isRounded: PropTypes.bool,
    isShadow: PropTypes.bool,
    placeHolder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.string,
    onChange: PropTypes.func,
    valid: PropTypes.bool,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    isLocked:PropTypes.bool
}

Input.defaultProps = {
    valid: true,
    isBorder: false,
    isRounded: false,
    isShadow: false,
    direction: 'left',
    value: '',
    isLocked:false
};

export default Input;


// WEBPACK FOOTER //
// ./src/components/Input/Input.js